import React, { Component } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip"

class NewsPage extends Component {

  componentDidMount(){
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="University of Leeds' transport contract extended " description="Tetley's Coaches is one of only three coach operators on the University of Leeds' transport supplier framework agreement." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article" style={{ background: 'white' }}>
            <div>
              <h1 className="page-content-heading">University of Leeds' transport contract extended to July 2017</h1>
              <p className="news-article-date">June 2016</p>
            </div>

            <div className="news-article-body">
              <p>Tetley's Coaches is one of only three coach operators on the University of Leeds' transport supplier framework agreement.</p>
              <p>The 3 year contract commenced in August 2013 following a comprehensive tender process.</p>
              <p>We provide staff, student and visitor transport for numerous events including open days, sporting events and educational visits.</p>
              <p>We are proud to announce that the University have taken up the option to extend the contract by an extra year.</p>
            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default NewsPage
